<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <!--<iframe src="https://tn-wind.industrialmedia.com.ua/" width="100%" height="1000px" align="left">
            Ваш браузер не поддерживает плавающие фреймы!
          </iframe>-->
          <button @click="post">SOOQA</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import axios from 'axios';

export default {
  data() {
    return {
      arr: [],
    };
  },
  components: {
  },
  methods: {
    post() {
      const postData = new URLSearchParams();
      postData.append('data', JSON.stringify(this.arr));
      axios.post('https://tn-calc.industrialmedia.com.ua/action/service_api/test', postData)
        .then((response) => {
          console.log(response);
        });
    },
  },
  watch: {
  },
  mounted() {
  },
  computed: {
  },
};
</script>
<style lang="sass" scoped>
  button
    font-size: rem(300)
    cursor: pointer
</style>
